import { createApp } from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { VDateInput } from 'vuetify/labs/VDateInput'
import '@mdi/font/css/materialdesignicons.css'
import VueSignature from 'vue3-signature'
import flatPickr from "vue-flatpickr-component"
import "flatpickr/dist/flatpickr.css"

import Sortable from "sortablejs"

const vuetify = createVuetify({
  components: {
    ...components,
    VDateInput,
  },
  directives,
  // UK date format (DD/MM/YYYY) and Monday-first calendars for all date inputs/pickers
  date: {
    locale: { en: 'en-GB' }
  },
  defaults: {
    VDateInput: { inputFormat: 'dd/mm/yyyy' }
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#7a003c',
        }
      }
    }
  }
})

const app = createApp(App)

app.directive("sortable", {
  mounted: function(el, binding) {
    new Sortable(el, binding.value || {})
  }
})

app.use(vuetify)
app.use(router)
app.use(store)

app.component('Vue3Signature', VueSignature)
app.component('flatPickr', flatPickr)

router.beforeResolve((to, from, next) => {
  store.state.menuVisible = false

  if (to.meta.isPublic) next()
  else if (to.meta.isAdmin)
    if (store.state.user && store.state.user.role == "admin") next()
    else next({ name: "engineer-schedule" })
  else if (store.state.user) next()
  else next({ name: "login" })
})

app.mount("#app")
